import { useQuery } from './use-query.hook';

export function useQueryCoords() {
    const query = useQuery();
    const latitude = parseFloat(query.get('latitude'));
    const longitude = parseFloat(query.get('longitude'));
    return { latitude, longitude };
}
